import { Action, Module, VuexModule } from "vuex-module-decorators";
import { RootState } from "@/store";
import { queryRequest } from "@/utils/request";
import { getActivity, newCouponToReceive } from "@/graphql/activity.gql";

export interface MallActivityState {}

@Module({ name: "MallActivityModule", namespaced: true })
export default class MallActivityModule
  extends VuexModule<MallActivityState, RootState>
  implements MallActivityState {
  @Action
  async getActivityAction(activityCode) {
    const res = await queryRequest({
      query: getActivity,
      variables: {
        activityCode
      }
    });
    return res;
  }

  @Action
  async sendCouponToUsersAction(variables) {
    return await queryRequest({
      query: newCouponToReceive,
      variables
    });
  }
}
